/**
 * Load all notifications
 * */
import { createAction, props } from '@ngrx/store';
import { UserNotificationInput } from '../../../shared/data/inputs/user-notification.input';
import { MyNotificationModel } from '../../../shared/data/models/my-notification.model';
import { ReadNotificationInput } from '../../../shared/data/inputs/read-notification.input';
import { NotificationModel } from '../../../shared/data/models/notification.model';
import { DeleteNotificationInput } from '../../../shared/data/inputs/delete-notification.input';

export const loadNotification = createAction(
  '[Notifications] load all Notifications',
  props<{ payload?: UserNotificationInput }>()
);

// export const loadAllMentionNotification = createAction(
//   '[Notifications] load all Mention Notifications'
// );

export const loadNotificationError = createAction(
  '[Notifications] Load Notification Error',
  props<{ error: string }>()
);

export const loadNotificationSuccess = createAction(
  '[Notifications] load Notifications Success',
  props<{ payload: MyNotificationModel }>()
);

export const loadMoreNotification = createAction(
  '[Notifications] Load More Notifications',
  props<{ payload?: UserNotificationInput }>()
);

export const loadMoreNotificationSuccess = createAction(
  '[Notifications] Load More Notifications Success',
  props<{ payload: MyNotificationModel }>()
);

// mark as read
export const markAsReadNotification = createAction(
  '[Notifications] Mark As Read Notification',
  props<{ payload: ReadNotificationInput }>()
);

export const markAsReadNotificationSuccess = createAction(
  '[Notifications] Mark As Read Notification Success',
  props<{ payload: NotificationModel }>()
);

export const notificationError = createAction(
  '[Notifications] Mark As Read Notification Error',
  props<{ payload: { notificationID: string; error: string } }>()
);

// delete notification
export const deleteNotification = createAction(
  '[Notifications] Delete Notification',
  props<{ payload: DeleteNotificationInput }>()
);

export const deleteNotificationSuccess = createAction(
  '[Notifications] Delete Notification Success',
  props<{ payload: { notificationID: string } }>()
);

// reading all notification
export const readAllNotification = createAction(
  '[Notifications] Read All Notification'
);

export const readAllNotificationSuccess = createAction(
  '[Notifications] Read All Notification Success'
);

export const readAllNotificationError = createAction(
  '[Notifications] Read All Notification Error',
  props<{ error: string }>()
);

// delete all notifications
export const deleteAllNotification = createAction(
  '[Notifications] Delete All Notifications'
);

export const deleteAllNotificationSuccess = createAction(
  '[Notifications] Delete All Notifications success'
);

export const deleteAllNotificationError = createAction(
  '[Notifications] Delete All Notifications error',
  props<{ error: string }>()
);
